import { LogIn, PanelLeft, PanelLeftClose } from 'lucide-react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../components/icons';
import { Tooltip } from '../components/tooltip';
import { GuestChatView } from '../views/guest-chat-view/guest-chat-view';
import { cn } from '../utils/cn';

const isMobile = () => window.matchMedia('(max-width: 639px)').matches;

export const GuestChatPage: React.FC = () => {
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = React.useState(true);

  return (
    <div className="h-screen w-full flex flex-col bg-background">
      {/* Minimal Toolbar */}
      <header
        className={cn(
          'flex items-center px-2 sm:px-4 h-14 w-full',
          'bg-background/95 backdrop-blur-sm border-b border-border',
          'z-1'
        )}
      >
        <div className="flex h-full w-full items-center justify-between">
          {/* Left: Logo */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <Logo />
          </div>

          {/* Right: Controls */}
          <div className="flex items-center gap-1 sm:gap-2 scale-75 sm:scale-100">
            {/* Sidebar toggle */}
            <Tooltip
              content={showSidebar ? 'Hide Sidebar' : 'Show Sidebar'}
              side="left"
              delay={300}
            >
              <button
                type="button"
                onClick={() => setShowSidebar(prev => !prev)}
                className={cn(
                  'h-8 w-8 flex items-center justify-center rounded-md',
                  'hover:bg-accent/50 active:scale-95 transition-all duration-200',
                  'text-muted-foreground hover:text-foreground'
                )}
                aria-label={showSidebar ? 'Hide sidebar' : 'Show sidebar'}
              >
                {showSidebar ? (
                  <PanelLeftClose className="w-4 h-4" />
                ) : (
                  <PanelLeft className="w-4 h-4" />
                )}
              </button>
            </Tooltip>

            {/* Sign In Button */}
            <Tooltip content="Sign in for unlimited chats" side="left" delay={300}>
              <button
                type="button"
                onClick={() => navigate('/signin')}
                className={cn(
                  'flex items-center gap-1.5 h-8 px-3 rounded-md text-sm font-medium',
                  'glass-button text-white',
                  'active:scale-95 transition-all duration-200'
                )}
                aria-label="Sign in"
              >
                <LogIn className="w-3.5 h-3.5" />
                <span className="hidden sm:inline">Sign in</span>
              </button>
            </Tooltip>
          </div>
        </div>
      </header>

      {/* Chat View */}
      <div className="flex-1 min-h-0">
        <GuestChatView
          showSessionPanel={showSidebar}
          onSessionSelect={() => {
            if (isMobile()) setShowSidebar(false);
          }}
        />
      </div>
    </div>
  );
};
